import { render, staticRenderFns } from "./PrivacyAndPolicy.vue?vue&type=template&id=dc35c9a6&scoped=true&"
import script from "./PrivacyAndPolicy.vue?vue&type=script&lang=js&"
export * from "./PrivacyAndPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc35c9a6",
  null
  
)

export default component.exports